'use client'

import { useState } from 'react'

import Button from '@/components/Button/Button'
import Icon from '@/components/Icon/Icon'

import { useAuth } from './AuthContext'

import authStyles from './Auth.module.scss'
import styles from './MFASelectForm.module.scss'
import classNames from 'classnames/bind'

const authClasses = classNames.bind(authStyles)
const classes = classNames.bind(styles)

export default function MFASelectForm() {
    const { selectMfaType, mfaSession } = useAuth()
    const [selectedMethod, setSelectedMethod] = useState(null)
    const [loading, setLoading] = useState(false)

    const handleSubmit = async () => {
        if (!selectedMethod || loading) return
        setLoading(true)
        try {
            await selectMfaType(selectedMethod)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <form
                className={authClasses('form')}
                onSubmit={(e) => {
                    e.preventDefault()
                    handleSubmit()
                }}
            >
                <h1 className={authClasses('title')}>Select Verification Method</h1>
                <p className={authClasses('subtext')}>Choose how you'd like to receive your verification code.</p>

                <div className={classes('mfa-options')}>
                    <button
                        type="button"
                        className={classes('mfa-option', {
                            'mfa-option--selected': selectedMethod === 'SOFTWARE_TOKEN_MFA',
                        })}
                        onClick={() => setSelectedMethod('SOFTWARE_TOKEN_MFA')}
                    >
                        <div className={classes('mfa-option-icon')}>
                            <Icon name="smartphone" width={24} height={24} />
                        </div>
                        <div className={classes('mfa-option-content')}>
                            <h3>Authenticator App</h3>
                            <p>Use your authenticator app to get a verification code</p>
                        </div>
                    </button>

                    <button
                        type="button"
                        className={classes('mfa-option', {
                            'mfa-option--selected': selectedMethod === 'SMS_MFA',
                        })}
                        onClick={() => setSelectedMethod('SMS_MFA')}
                    >
                        <div className={classes('mfa-option-icon')}>
                            <Icon name="message-square" width={24} height={24} />
                        </div>
                        <div className={classes('mfa-option-content')}>
                            <h3>Text Message (SMS)</h3>
                            <p>Receive a verification code via SMS</p>
                        </div>
                    </button>
                </div>
            </form>

            <Button
                className={authClasses('login-button')}
                onClick={handleSubmit}
                text={loading ? 'Sending...' : 'Continue'}
                disabled={!selectedMethod || loading}
            />
        </>
    )
}
